export default __webpack_public_path__ + "static/media/glxt.12034b86.svg";